// src/components/IncomingOrders/ViewDialog/SettingsPopupMenu.jsx

import PropTypes from "prop-types";

import {
  Box,
  ListSubheader,
  Menu,
  Typography,
} from "@mui/material";

const settingsMenuPaperSx = {
  mt: 0.75,
  borderRadius: "12px",
  border: "1px solid",
  borderColor: "divider",
  bgcolor: "background.paper",
  boxShadow: "0 12px 34px rgba(0,0,0,0.18)",
  overflow: "hidden",
  py: 0.5,
};

const SettingsPopupMenu = ({
  anchorEl,
  open,
  onClose,
  title,
  subtitle,
  children,
}) => (
  <Menu
    keepMounted
    anchorEl={anchorEl}
    open={open}
    onClose={onClose}
    anchorOrigin={{ vertical: "center", horizontal: "right" }}
    transformOrigin={{ vertical: "center", horizontal: "left" }}
    disablePortal={false}
    sx={{ zIndex: (theme) => theme.zIndex.modal + 10 }}
    PaperProps={{
      elevation: 8,
      sx: settingsMenuPaperSx,
    }}
    disableAutoFocusItem
    disableEnforceFocus
  >
    <ListSubheader
      disableSticky
      sx={{
        px: 2,
        pt: 1.25,
        pb: 0.75,
        bgcolor: "background.paper",
        lineHeight: 1.2,
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          fontSize: 13,
          fontWeight: 600,
          color: "text.primary",
        }}
      >
        {title}
      </Typography>

      {subtitle && (
        <Typography
          sx={{
            mt: 0.25,
            fontSize: 11,
            color: "text.secondary",
          }}
        >
          {subtitle}
        </Typography>
      )}
    </ListSubheader>

    <Box sx={{ overflowY: "auto", maxHeight: "80vh" }}>
      {children}
    </Box>
  </Menu>
);

SettingsPopupMenu.propTypes = {
  anchorEl: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      nodeType: PropTypes.number,
    }),
  ]),
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  children: PropTypes.node,
};

export default SettingsPopupMenu;
